<template>
  <div  class="app-wrapper">
    <Header class="Header-container" />
    <div class="main-container clearfix" v-if="!isUpload">
      <div class="main-container-box">
        <Banner v-if="isShow"></Banner>
        <app-main/>
      </div>
      <div class="main-container-right" ref="element" :class="{active:active}">
        <Right></Right>
      </div>
    </div>
    <div class="main-container clearfix" v-if="isUpload">
      <app-main/>
    </div>
  </div>
</template>

<script>
import { Header,Banner,Right,AppMain} from './components'

export default {
  name: 'Layout',
  data () {
    return {
      
      isShow:false,
      isUpload:false,
      active:false
    }
  },
  components: {
    Header,
    Banner,
    Right,
    AppMain,
  },
  created () {
     this.getRoute()

  },
  mounted () {    
    
     window.addEventListener('scroll', this.getScrollTop);
  },
  watch: {
    $route () {
      this.getRoute()
    }
  },
  methods:{
    getScrollTop() {
        var scrollTop = 0,
            bodyScrollTop = 0,
            documentScrollTop = 0,
            offsetHeight = this.$refs.element.offsetHeight,
            clientHeight = 0,
            documentScrollLeft=0;
            
         
        if (document.body) {
            bodyScrollTop = document.body.scrollTop
        }
        if (document.documentElement) {
            documentScrollTop = document.documentElement.scrollTop;
            clientHeight = document.documentElement.clientHeight
            documentScrollLeft =document.documentElement.scrollLeft;
           
        }
        scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
        if(scrollTop> (offsetHeight-clientHeight)+150){
          this.active=true
        }else{
          this.active=false
        }

        if(this.active){
           this.$refs.element.style.marginLeft = 830-documentScrollLeft+'px'
        }else{
          this.$refs.element.style.marginLeft ='0px'
        }
       
    },
    getRoute(){
      if (this.$route.path == '/index') {
        this.isShow = true
      } else {
        this.isShow = false
      }
      if (this.$route.path == '/upload') {
        this.isUpload = true
      } else {
        this.isUpload = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.app-wrapper{
  min-width:980px;
  padding-top:48Px;
  // 主体区域
  .main-container {
   width:1205Px;
  //  min-width:960Px;
   margin:0 auto;
   box-sizing: border-box;
   padding:10Px 0;
   position:relative;
  }
  .main-container-box{
    display:inline-block;
    width:830Px;
    min-width:661Px;
    float:left;
   
  }
  .main-container-right{
    float:left;
    width:370Px;
    // min-width:298Px;
   
    &.active{
      position:fixed;
      margin-left:830Px;
      bottom: 0;
    }
  }
}
</style>
